import * as svg from "../../../assets/login-mobile-bg.svg";

import {iconBuilder} from "./iconBuilder";

export const LoginMobileBg = iconBuilder(svg, "LoginMobileBg", "0 0 367 123");
